function stringToDate(str?: string | null) {
  if (!str || str.length === 0) {
    return null;
  }
  return new Date(str);
}

function dateToUSFormat(date: Date | null, opts: Intl.DateTimeFormatOptions) {
  if (!date) {
    return null;
  }
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    ...opts,
  };
  return date.toLocaleString("en-US", options);
}

function dateIsAfterHighlight(
  highlightDate: Date,
  dateToCheck: Date | string | undefined | null,
) {
  if (!dateToCheck) return false;
  if (typeof dateToCheck === "string") {
    dateToCheck = new Date(dateToCheck);
  }
  return highlightDate.getTime() <= dateToCheck.getTime();
}

export const convertDate = {
  stringToDate,
  dateToUSFormat,
  dateIsAfterHighlight,
};
